export const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const DESKTOP_QUERY = '(min-width: 960px)';
